"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.serialize = exports.deserialize = void 0;
function deserialize(str) {
    const ss = str.split('\n');
    const ret = {};
    for (let idx = 0; idx < ss.length; idx++) {
        const line = ss[idx];
        const result = line.match(/\[submodule\s+\"(.*?)\"\]/);
        if (!result || result.length < 2) {
            continue;
        }
        const submodule = result[1];
        const obj = {};
        if (submodule) {
            let subline = ss[++idx];
            while (subline && subline.trim()) {
                subline = ss[idx];
                if (!subline || subline.match(/\[submodule\s+\"(.*?)\"\]/)) {
                    idx--;
                    break;
                }
                subline = subline.trim();
                const [subginal, key, value] = subline.match(/(.*?)\s*=\s*(.*)/);
                if (key && value) {
                    obj[key] = value;
                }
                idx++;
            }
            ret[submodule] = obj;
        }
    }
    return ret;
}
exports.deserialize = deserialize;
function serialize(obj) {
    if (!obj) {
        return '';
    }
    let str = '';
    const entries = Object.entries(obj);
    for (const [key, value] of entries) {
        str += `[submodule "${key}"]\n`;
        const values = Object.entries(value);
        for (const [left, right] of values) {
            str += `	${left} = ${right}\n`;
        }
        str += '\n';
    }
    return str;
}
exports.serialize = serialize;
//# sourceMappingURL=index.js.map